module.exports = __webpack_public_path__ + "img/media-hub.17547e7a.svg";